// Portal slugs are lower-case letters, digits and hyphens (what Admin's
// slugify produces). The slug comes from the URL and is interpolated into an
// Airtable formula, so anything else is treated as not found before it gets
// near one. This only closes formula injection from the URL; the real fix is
// proxy-side scoping (the proxy deciding which rows a caller may read), see
// docs/SECURITY.md. While the proxy key is public, a caller can bypass this.
const SLUG = /^[a-z0-9-]{1,64}$/;

export function isValidSlug(s) {
  return typeof s === "string" && SLUG.test(s);
}

export function slugFilter(s) {
  return isValidSlug(s) ? `{Slug} = "${s}"` : null;
}
